import partQueries from "$/lib/queries/part-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/component-actions")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(partQueries.adminList())
    return { crumb: "Komponentåtgärder" }
  },
})
